import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../../common/money';
import { t } from '../../../../modules/infra/i18n';

const TotalSalesAmount = ({ total, automationId }) => (
  <div className="c-total-sales-amount u-mt-auto">
    <div className="c-report-label u-type--uppercase u-m0">{t('reports:total_sales_amount.label')}</div>
    <div className="c-report-stat c-report-stat--medium">
      <Money automationId={automationId}>{total}</Money>
    </div>
  </div>
);
TotalSalesAmount.propTypes = {
  total: PropTypes.number,
  automationId: PropTypes.string,
};
TotalSalesAmount.defaultProps = {
  total: {},
  automationId: null,
};

export default TotalSalesAmount;
